var map = null;

document.addEventListener("DOMContentLoaded", function() {
	map = new google.maps.Map(document.getElementById('map'), {
		zoom: 17,
		center: mapLocation,
		streetViewControl: false,
		mapTypeControl: false,
	});

	marker1 = new google.maps.Marker({
		position: mapLocation,
		map: map,
		title: mapTitle,
    });

	recalcMapDimensions();
});

window.addEventListener("click", function(event) {
	var storeMap = document.getElementById("store-map");

	if (event.target == this.document.getElementById("store-view-map")) {
		storeMap.style.display = "inherit";
		recalcMapDimensions();
		storeMap.scrollIntoView(true);
	} else if (event.target == this.document.getElementById("map-underlay")){
		storeMap.style.display = "none";
	}
});

window.addEventListener("resize", function() {
	recalcMapDimensions();
});

function recalcMapDimensions() {
	var storeCarousel = document.getElementById("store-carousel");

	var storeMap = document.getElementById("store-map");

	storeMap.style.width = window.getComputedStyle(storeCarousel).width;
	storeMap.style.height = window.getComputedStyle(storeCarousel).height;
	
	google.maps.event.trigger(map, "resize");
}